/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeClass; });
/* unused harmony export scrollTop */
/* eslint-env browser */

function hasClass(el, className) {
  var classes = el.className.split(' ');
  for (var i = classes.length - 1; i >= 0; i--) {
    if (classes[i] === className) {
      return true;
    }
  }
  return false;
}
function addClass(el, className) {
  if (!hasClass(el, className)) {
    el.className += " ".concat(className); // eslint-disable-line
  }
}
function removeClass(el, className) {
  var classes = el.className.split(' ');
  for (var i = classes.length - 1; i >= 0; i--) {
    if (classes[i] === className) {
      classes.splice(i);
    }
  }
  el.className = classes.join(' '); // eslint-disable-line
}
function scrollTop() {
  return window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export request */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* unused harmony export getScript */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return post; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cookie__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__cookie__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* eslint-env browser */



/**
 * Make an AJAX request
 * Thanks to http://youmightnotneedjquery.com/
 */
function request(type, url, data, onsuccess, onerror) {
  var config = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  // Set defaults
  if (config.json === undefined) {
    config.json = true; // eslint-disable-line
  }
  if (config.sendCsrf === undefined) {
    config.sendCsrf = true; // eslint-disable-line
  }
  if (config.contentType === undefined) {
    config.contentType = 'application/json; charset=UTF-8'; // eslint-disable-line
  }

  // Convert data to string
  if (_typeof(data) === 'object') {
    data = JSON.stringify(data); // eslint-disable-line
  }
  var xhr = new XMLHttpRequest();
  xhr.open(type, url, true);
  if (config.sendCsrf) {
    var csrfToken = Object(__WEBPACK_IMPORTED_MODULE_0__cookie__["getCookie"])('YII_CSRF_TOKEN');
    if (type !== 'GET' && csrfToken === undefined) {
      // If no CRSF token is set, ping the server to get it (required for all
      // non-GET requests).
      ping(url, function () {
        request(type, url, data, onsuccess, onerror);
      }, onerror);
      return;
    }
    xhr.setRequestHeader('YII_CSRF_TOKEN', csrfToken);
  }

  // Note - config.contentType can be set to false if we don't want it sent.
  // e.g. for Slack integration which doesn't support this being set.
  if (config.contentType) {
    xhr.setRequestHeader('Content-Type', config.contentType);
  }
  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 400) {
      if (typeof onsuccess === 'function') {
        var response = xhr.responseText;
        if (config.json) {
          response = JSON.parse(xhr.responseText);
        }
        onsuccess(response);
      }
    } else if (typeof onerror === 'function') {
      onerror();
    }
  };
  xhr.onerror = onerror;
  xhr.send(data);
}
function get(url, onsuccess, onerror) {
  request('GET', url, null, onsuccess, onerror, {});
}
function getScript(url, onsuccess, onerror) {
  request('GET', url, null, onsuccess, onerror, {
    contentType: 'text/plain;charset=UTF-8'
  });
}
function post(url, data, onsuccess, onerror) {
  var config = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  request('POST', url, data, onsuccess, onerror, config);
}
function ping(originalUrl, onsuccess, onerror) {
  get('/api/ping', onsuccess, onerror, {});
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/* eslint-env browser */

/**
 * Get cookie value by name
 * Thanks to http://stackoverflow.com/questions/10730362/get-cookie-by-name
 */
function getCookie(name) {
  var value = "; ".concat(document.cookie);
  var parts = value.split("; ".concat(name, "="));
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return undefined;
}
module.exports = {
  getCookie: getCookie
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Partners; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partner_list__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_source_js_util_ajax__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_source_js_util_dom__ = __webpack_require__(0);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-env browser */
/* eslint-env jquery */

// Shared services
// import InstantEvents from '../../../../shared/source/js/services/instantEvents/instantEvents';
// Page components



// import PartnerService from './partner-service';
// import PartnerFilters from './partner-filters';
var Partners = /*#__PURE__*/function () {
  function Partners(options) {
    _classCallCheck(this, Partners);
    this.activateLocationFilter();
    this.activateServicesFilters();
    this.activateToggle();
    this.partnerList = new __WEBPACK_IMPORTED_MODULE_0__partner_list__["a" /* default */]();
    this.refresh();
  }
  return _createClass(Partners, [{
    key: "activateLocationFilter",
    value: function activateLocationFilter() {
      // Set up with select2
      $('select.filter-location').select2();

      // Listen for changes
      document.querySelector('.filter-location').onchange = this.refresh.bind(this);
    }
  }, {
    key: "activateServicesFilters",
    value: function activateServicesFilters() {
      var _this = this;
      // Listen to service filter changes
      this.serviceInputArray = Array.prototype.slice.call(document.querySelectorAll('input[name="services"]'));
      this.serviceInputArray.forEach(function (input) {
        input.onchange = _this.refresh.bind(_this); // eslint-disable-line
      });
    }
  }, {
    key: "activateToggle",
    value: function activateToggle() {
      var _this2 = this;
      // eslint-disable-line
      document.querySelector('.toggle-filters').onclick = function () {
        if (_this2.innerHTML === 'Filter partners') {
          Object(__WEBPACK_IMPORTED_MODULE_2__shared_source_js_util_dom__["c" /* removeClass */])(document.querySelector('#filters'), 'hidden-md-down');
          _this2.innerHTML = 'Hide filters';
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_2__shared_source_js_util_dom__["a" /* addClass */])(document.querySelector('#filters'), 'hidden-md-down');
          _this2.innerHTML = 'Filter partners';
        }
      };
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this3 = this;
      var filters = this.getFilters().join('&');
      var country = this.getCountry();
      this.partnerList.showLoading();
      Object(__WEBPACK_IMPORTED_MODULE_1__shared_source_js_util_ajax__["a" /* get */])("/api/v2/".concat(country ? "countries/".concat(country, "/") : '', "partners?").concat(filters), function (res) {
        // eslint-disable-line
        this.partnerList.setPartners(res);
        this.updateFilterMessage(filters, country, res.length);
        this.partnerList.showLoading(false);
      }.bind(this), function () {
        document.querySelector('.loader').innerHTML = '<p class="text-muted">Sorry, we could not load the partners. Please try refreshing.</p>';
        _this3.partnerList.showLoading(false);
      });
    }
  }, {
    key: "getFilters",
    value: function getFilters() {
      var filters = [];
      if (!document.querySelector('.filter-location').value) {
        filters.push('filter[order]=averageRating DESC,numReviews DESC,organization ASC');
      }
      this.serviceInputArray.forEach(function (input) {
        if (input.checked) {
          filters.push('filter[where][' + input.value + ']=true'); // eslint-disable-line
        }
      });
      return filters;
    }
  }, {
    key: "getCountry",
    value: function getCountry() {
      // eslint-disable-line
      return document.querySelector('.filter-location').value;
    }
  }, {
    key: "updateFilterMessage",
    value: function updateFilterMessage(filters, country, numResults) {
      // eslint-disable-line
      if (filters.indexOf('where') === -1) {
        document.querySelector('.filters-message-lg-up').innerHTML = 'Find a partner near you using the filters on the right';
        document.querySelector('.filters-message-lg-up').style.fontWeight = 'normal';
        document.querySelector('.filters-message-md-down').innerHTML = 'Showing all partners';
        document.querySelector('.filters-message-md-down').style.fontWeight = 'normal';
      } else {
        var message;
        if (!numResults) {
          message = 'Sorry, no partners match your filters';
        } else if (numResults === 1) {
          message = '1 partner matches your filters:';
        } else {
          message = "".concat(numResults, " partners match your filters:");
        }
        document.querySelector('.filters-message-lg-up').innerHTML = message;
        document.querySelector('.filters-message-lg-up').style.fontWeight = 'bold';
        document.querySelector('.filters-message-md-down').innerHTML = message;
        document.querySelector('.filters-message-md-down').style.fontWeight = 'bold';
      }
    }
  }]);
}();

new Partners(); // eslint-disable-line

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PartnerList; });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-env browser */
var PartnerList = /*#__PURE__*/function () {
  function PartnerList() {
    _classCallCheck(this, PartnerList);
  }
  return _createClass(PartnerList, [{
    key: "showLoading",
    value:
    // eslint-disable-next-line class-methods-use-this
    function showLoading(loading) {
      loading = loading === false ? false : true; // eslint-disable-line
      document.querySelector('.loader').style.display = loading ? 'block' : 'none';
      document.querySelector('.content').style.display = loading ? 'none' : 'block';
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "setPartners",
    value: function setPartners(partners) {
      var partnerBoxes = [];
      partners.forEach(function (partner) {
        var numReviews;
        if (!partner.numReviews) {
          numReviews = 'no reviews';
        } else if (partner.numReviews === 1) {
          numReviews = '1 review';
        } else {
          numReviews = "".concat(partner.numReviews, " reviews");
        }
        var stars = getRatingStars(partner.averageRating, partner.numReviews);
        var initials = partner.organization.split(' (')[0].split(' ').map(function (s) {
          return s.charAt(0);
        }).join('');
        partnerBoxes.push("\n        <div class=\"card partner-box\">\n          <div class=\"card-block\">\n            <div class=\"row\">\n              <div class=\"col-sm-2 partner-box-logo hidden-xs-down\">\n                ".concat(partner.logo ? "<img src=\"".concat(partner.logo, "\" alt=\"").concat(partner.organization, " logo\">") : "<div class=\"circle-initials\"\n                    style=\"\n                      width:72px;height:72px;text-align:center;line-height:72px;\n                      color:#FFF;background-color:#AAA;border-radius:50%;margin:0 auto\n                    \">".concat(initials, "</div>"), "\n              </div>\n              <div class=\"col-sm-10\">\n                <div class=\"float-sm-right hidden-sm-down\">\n                  <a class=\"btn btn-sm btn-success btn-top-right\"\n                    href=\"/partners/").concat(partner.urlName, "#contact\">\n                    Contact partner\n                  </a>\n                </div>\n                <h3><a href=\"/partners/").concat(partner.urlName, "\">").concat(partner.organization, "</a></h3>\n                <a href=\"/partners/").concat(partner.urlName, "#reviews\"\n                  class=\"partner-box-stars text-muted heading-subtext\">\n                  ").concat(stars, "\n                  <span class=\"partner-box__lbl-num-reviews\">(").concat(numReviews, ")</span>\n                </a>\n                <p>\n                  ").concat(partner.services, "\n                  <a href=\"/partners/").concat(partner.urlName, "\">View profile</a>\n                </p>\n                <ul class=\"list-inline text-muted text-sub\" style=\"margin-bottom:0\">\n                  <li class=\"list-inline-item\">\n                    Working ").concat(partner.customerLocations, "\n                  </li>\n                </ul>\n                <a class=\"btn btn-success hidden-md-up\"\n                  href=\"/partners/").concat(partner.urlName, "#contact\" style=\"margin-top:1rem\">\n                  Contact partner\n                </a>\n              </div>\n            </div>\n          </div>\n        </div>\n      "));
      });
      document.querySelector('#partner-list').innerHTML = partnerBoxes.join('');
      function getRatingStars(rating, numReviews) {
        var stars = '';
        for (var i = 0; i < 5; i++) {
          if (rating <= i) {
            stars += "<i class=\"icon-star-empty".concat(!numReviews ? ' icon-star-muted' : '', "\"></i>");
          } else if (rating - 0.5 === i) {
            stars += '<i class="icon-star-half"></i>';
          } else {
            stars += '<i class="icon-star"></i>';
          }
        }
        return stars;
      }
    }
  }]);
}();


/***/ })
/******/ ]);